<template>
	<div class="component poll uk-position-relative">
		
		<div v-show="showTitle">
			<h3 class="title" v-if="hasEntryPage"><a :href="pollData.url">{{ pollData.title }}</a></h3>
			<h3 class="title" v-else>{{ pollData.title }}</h3>
		</div>
		
		<div class="uk-alert" v-if="isExpired == true">
			Poll geëindigd, er kan niet meer gestemd worden.
		</div>
		<div class="results" v-html="results"></div>
		
		<div class="poll-results" v-show="hasParticipated" v-html="pollResults"></div>
		
		<div class="poll-form" v-show="results == null && !hasParticipated">
			
			<form 
				ref="form"
				method="post" 
				action="/actions/poll/answer/submit" 
				class="poll-form" 
				:id="'poll-form-' + uniqueId"
				@submit.prevent="vote"
			>
				<!-- hidden required inputs -->
				<input type="hidden" :name="csrfName" :value="csrfToken">
				<div v-html="pollInputs"></div>
		
				<!-- answers -->
				<div class="poll-answers">
					<div v-for="answer in answerData" :key="answer.id" class="answer-container">
						
						<div class="uk-grid-small" uk-grid>
							<div class="uk-width-auto">
								<input
									type="radio"
									:name="generatePollAnswerFieldName(pollData, answer)"
									:value="generatePollAnswerFieldValue(pollData, answer)"
									class="uk-radio"
									:id="'option-radio-' + answer.id + '-' + id"
									required
								/>
							</div>
							<div class="uk-width-expand">
								<label
									:for="'option-radio-' + answer.id + '-' + id"
									style="margin-top: -3px;"
									class="uk-text-small"
								>
									{{ answer.label }}
								</label>
							</div>
						</div>
						
					</div>
				</div>

				<div class="footer uk-margin-small-top" v-if="showTotalComments">
					<span v-if="showTotalComments">
						<a :href="pollData.url">{{ totalComments }} <span uk-icon="icon: comments"></span></a>
					</span>
				</div>
				
				<div class="uk-margin-top">
					<button class="uk-button uk-button-small uk-button-primary uk-margin-remove">Stemmen</button>
				</div>
															
			</form>
		</div>

		<div class="overlay" v-show="overlay">
			 <div class="uk-position-center">
					 <div class="uk-text-center">
						 <span v-show="loading"><loading-indicator></loading-indicator></span>
						 <span v-show="error" class="material-symbols-outlined"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg></span>
						 <span v-show="success" class="material-symbols-outlined"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg></span>
					 </div>
					 <p class="uk-text-center" v-html="message"></p>
			 </div>
		</div>
				
	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	name: 'Poll',
	components: { LoadingIndicator },
	props: {		
		pollData: {
			type: Object,
			required: true
		},
		pollInputs: {
			type: String,
			required: true
		},
		answerData: {
			type: Object,
			required: true		
		},
		isExpired: {
			type: Boolean
		},
		hasParticipated: {
			type: Boolean,
			default: false
		},
		showTitle: {
			type: Boolean,
			default: true			
		},
		showFooter: {
			type: Boolean,
			default: true
		},
		showUsers: {
			type: Boolean,
			default: false
		},
		showTotalComments: {
			type: Boolean,
			default: false
		},	
		showTotalVotes: {
			type: Boolean,
			default: true,
		},
		totalComments: {
			type: Number,
			default: 0
		},
		hasEntryPage: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			
			// Default
			uniqueId: Date.now().toString(36) + Math.random().toString(36).substring(2),
			overlay: false,
			error: null,
			success: false,
			loading: false,
			message: null,
			
			pollResults: null,
			
			// Poll specific
			results: null,
			resultUrl: '/async/poll_results',
			hasVoted: false,
			CFG_FORM_POLLANSWER_FIELDNAME: '__answer',
			CFG_FORM_POLLANSWERTEXT_FIELDNAME: '__text'
		}
	},
	mounted() {
		this.$logger("app/component/poll/mounted/id:" + this.uniqueId);
		
		if(this.hasParticipated) {
			this.loadPollResults();
		}
	},
	computed: {
		csrfName () {
			return window.csrfTokenName
		},
		csrfToken () {
			return window.csrfTokenValue
		},
	},
	methods: {
		generatePollAnswerFieldName(poll, answer) {
			var component = this;			
			return component.CFG_FORM_POLLANSWER_FIELDNAME + "[" + component.pollData.uid + "]";
		},
		generatePollAnswerFieldValue(poll, answer) {
			return answer.uid;
		},
		loadPollResults() {
			
			var component = this;

			// Pass all params 
			var resultParams = {
				uniqueId: component.uniqueId,
				pollId: component.pollData.id,
				showFooter: component.showFooter,
				showUsers: component.showUsers,
				showTotalComments: component.showTotalComments,
				showTotalVotes: component.showTotalVotes
			};
			
			// Load poll results
			axios.get('/async/poll_results', {
				params: resultParams,
			})
			.then(function (response) {
				component.pollResults = response.data;
		
				setTimeout(function () {
					component.animateBars();
				}, 300);
			})
			.catch(function (error) {
				console.log(error);
			});
						
		},
		vote(e) {
			
			var component = this;

			// Form data
			var form = e.target;
			var formData = new FormData(e.target);

			// Custom data
			var data = {};

			// Params passed to result template
			var resultParams = {
				uniqueId: component.uniqueId,
				pollId: component.pollData.id,
				showFooter: component.showFooter,
				showTotalComments: component.showTotalComments,
				showTotalVotes: component.showTotalVotes,
				showUsers: component.showUsers,
			};

			// Action and result URL
			var actionUrl = form.getAttribute("action");

			component.$logger("app/component/poll/vote/url:" + actionUrl);

			// Append CSRF
			formData.append(
				data[window.csrfTokenName],
				window.csrfTokenValue
			);

			// Toggle state
			component.overlay = true;
			component.loading = true;

			// Request
			axios({
				method: "post",
				url: actionUrl,
				responseType: "json",
				data: formData,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					Accept: "application/json",
				},
			})
			.then(function (response) {
				// Error
				if (response.data.error) {
					component.$logger("app/component/poll/response/error", "error");

					component.error = true;
					component.message = response.data.error;

					setTimeout(function() {
						component.resetMessage();
					}, 3000);
									
				// Success
				} else {
					component.$logger("app/component/poll/results/response/success");

					// Load poll results
					axios
						.get(component.resultUrl, {
							params: resultParams,
						})
						.then(function (response) {
							// Update results data							
							component.results = response.data;

							// Toggle state
							component.overlay = false;
							component.loading = false;

							setTimeout(function () {
								component.animateBars();
							}, 300);
						})
						.catch(function (error) {
							console.log(error);
						});
				}
			})
			.catch(function (error) {
				console.error(error);
			});
		},
		animateBars: function () {
			this.$logger("app/component/poll/animateBars");

			var component = this;

			var poll = document.getElementById(
				"poll-result-options-" + component.uniqueId
			);
			
			var bars = poll.getElementsByClassName("uk-progress");
			var animate = [];
			var barsCompleted = 0;
			var barsIntervals = [];

			for (var i = 0; i < bars.length; i++) {
				var bar = bars[i];
				var currentValue = parseInt(bar.value);
				var targetValue = parseInt(bar.getAttribute("target"));
				bar.value = targetValue;
			}
		},
		resetMessage: function() {
			var component = this;

			component.message = null;
			component.error = false;
			component.overlay = false;
			component.loading = false;		
		}		
	},
};
</script>
